import { ValValidationModule } from './common/modules/val-validation/val-validation.module';
import { ValTextBoxModule } from './common/modules/val-text-box/val-text-box.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ValDropDownModule } from './common/modules/val-drop-down/val-drop-down.module';
import { ValCommonModule } from './common/val-common.module';
import { ValForgotPasswordComponent } from './components/val-forgot-password.component';
import { ValLoginComponent } from './components/val-login.component';
import { ValMainComponent } from './components/val-main.component';
import { ValAuthInterceptor } from './http-interceptors/val-auth.interceptor';
import { ValAuthGuard } from './services/val-auth.guard';
import { ValBrowserStorageResolver } from './services/val-browser-storage.resolver';
import { ValBrowserStorageService } from './services/val-browser-storage.service';
import { ValCategoryLookupResolver } from './services/val-category-lookup.resolver';
import { ValChildAuthGuard } from './services/val-child-auth.guard';
import { ValCompanyResolver } from './services/val-company.resolver';
import { ValConfigService } from './services/val-config.service';
import { ValPosLookupResolver } from './services/val-pos-lookup.resolver';
import { ValRouteUtilsService } from './services/val-route-utils.service';
import { ValStorageService } from './services/val-storage.service';
import { ValUtilsService } from './services/val-utils.service';
import { ValService } from './services/val.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


@NgModule({
  declarations: [
    AppComponent,
    ValLoginComponent,
    ValMainComponent,
    ValForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    ValDropDownModule,
    ValCommonModule,
    ValTextBoxModule,
    ValValidationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true, //environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ValAuthInterceptor, multi: true },
    ValUtilsService,
    ValStorageService,
    ValBrowserStorageService,
    ValConfigService,
    ValService,
    ValAuthGuard,
    ValChildAuthGuard,
    ValRouteUtilsService,
    ValUtilsService,
    ValCategoryLookupResolver,
    ValPosLookupResolver,
    ValBrowserStorageResolver,
    ValCompanyResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
